<template>
	<div class="dialog-box">
		<div v-if="keyWord === 'search'" class="title">数据处理中</div>
		<el-progress v-if="(keyWord === 'search' || ((keyWord === 'export') && percentage !== 100))" type="circle" :percentage="percentage" color="var(--fx-primary-color)"></el-progress>
		<div v-if="(keyWord === 'search' || (keyWord === 'export') && percentage !== 100)" class="tips1">正在处理，请稍等...</div>
		<div v-if="(keyWord === 'export') && percentage === 100">
			<a style="display:flex;align-items: center;color:var(--fx-primary-color)" :href="reportUrl">
				<i class="excle-icon"></i>
				下载Excel文件
			</a>
		</div>
		<div  v-if="(keyWord === 'export') && percentage === 100" style='margin-top: 20px;'>
			<el-button size="mini" plain @click="cancelClick">取消</el-button>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Progress',
	props: {
		keyWord: {
			type: String
		},
		reportUrl: {
			type: String
		}
	},
	data () {
		return {
			timer: null,
			percentage: 0
		}
	},
	created () {
		this.loop()
	},
	watch: {
		percentage: {
			handler (val) {
				if (val === 100) {
					clearInterval(this.timer)
					this.timer = null
					if (this.keyWord === 'search') {
						setTimeout(() => {
							this.$emit('update:progressModal', false)
						}, 500)
					}
				}
			},
			immediate: true
		}
	},
	beforeDestroy () {
		clearInterval(this.timer)
		this.timer = null
	},
	methods: {
		cancelClick () {
			this.$emit('update:progressModal', false)
		},
		loop () {
			this.timer = setTimeout(() => {
				this.percentage = this.percentage + 2
				if (this.percentage > 99) {
					this.percentage = 99
				}
				this.loop()
			}, 1000)
		}
	}
}
</script>

<style lang="stylus" scoped>
	.dialog-box {
		display: flex
		flex-flow: column
		align-items: center
		justify-content: center
		.title, .tips1 {
			font-size: 15px;
			font-weight: bold;
			color: #333333;
			padding: 18px 0
		}
		.tips2 {
			font-size: 12px;
			font-weight: 400;
			color: #808080;
		}
	}
	.excle-icon {
			background-image:url('~images/icon/reportform/excle-icon.png')
			background-repeat:no-repeat
			background-position: center
			width:40px
			height:36px
			display:inline-block
		}
</style>
<style lang="stylus">
/* 环形进度条描边与文字使用主题色（与青橙一致） */
.dialog-box >>> .el-progress-circle__path
	stroke var(--fx-primary-color) !important
.dialog-box >>> .el-progress__text
	color var(--fx-primary-color) !important
</style>
